import { documentationActions } from '../../actions/constant';

const { SUCCESS_GET_ALL_SUPERVISIORS, FAILURE_GET_ALL_SUPERVISIORS, LOADING_GET_ALL_SUPERVISIORS } =
  documentationActions;

const intitialstate: object = {
  response: null,
  areGettingSupervisiors: false,
  loading: false,
};

export const getAllSupervisorsReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case SUCCESS_GET_ALL_SUPERVISIORS: {
      return {
        ...state,
        areGettingSupervisiors: true,
        response: action.payload,
        loading: false,
      };
    }

    case FAILURE_GET_ALL_SUPERVISIORS:
      return {
        ...state,
        areGettingSupervisiors: false,
        response: action.payload,
        loading: false,
      };

    case LOADING_GET_ALL_SUPERVISIORS:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
};
